import { render, staticRenderFns } from "./SquatationCreate.vue?vue&type=template&id=5e9103aa&scoped=true"
import script from "./SquatationCreate.vue?vue&type=script&lang=js"
export * from "./SquatationCreate.vue?vue&type=script&lang=js"
import style0 from "./SquatationCreate.vue?vue&type=style&index=0&id=5e9103aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9103aa",
  null
  
)

export default component.exports